// Tandem AI Tool System — extends core AIToolSystem with no app-type filtering (desktop-only surface).

import { AIToolSystem } from "../../../base/AIToolSystem.js";

export class TandemAIToolSystem extends AIToolSystem {
  /**
   * Hide tools that are not allowed on the active tandem lane (e.g. orchestration tools on engineer).
   * @param {string|null} modelId
   */
  getToolsForModel(modelId = null) {
    const lane = this.aiInferenceSystem?.getActiveLane?.() || null;
    const toolDefinitions = [];

    for (const [, toolEntry] of this.tools.entries()) {
      let toolData = null;

      if (modelId && toolEntry[modelId]) {
        toolData = toolEntry[modelId];
      } else if (toolEntry.default) {
        toolData = toolEntry.default;
      }

      if (!toolData) {
        continue;
      }

      const tool = toolData.tool;
      const lanes = tool?.tandemLaneIds;
      if (
        lane &&
        Array.isArray(lanes) &&
        lanes.length > 0 &&
        !lanes.includes(lane)
      ) {
        continue;
      }

      toolDefinitions.push(toolData.definition);
    }

    return toolDefinitions;
  }
}
